module.exports = __webpack_public_path__ + "static/media/Envelope signed &.1a6a5c17.webp";